import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageES() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Análisis de Relaciones con IA | Detecta Patrones Tóxicos y Gaslighting" description="Averigüe si su ex es el problema. Suba sus chats a la IA de ToxicDetector para un análisis instantáneo y confidencial de manipulación, gaslighting y señales de alerta. Comience el escaneo gratuito hoy." keywords="análisis de relaciones con IA, detectar patrones tóxicos, detector de gaslighting, ex tóxico, verificador de manipulación, toxicidad en relaciones, escáner de texto con IA" canonical="https://toxicdetector.com/es" language="es-MX" alternateUrls={alternateUrls} data-id="element-5097" data-mp="6gql25apz5dc" />
      <GoogleTranslateWidget data-id="element-5098" data-mp="npt4gv3pzb4j" />
      <PromoBanner data-id="element-5099" data-mp="nqujfanuwhrj" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5100" data-mp="nqbc0nvu1brr">
        <Header data-id="element-5101" data-mp="ix03mibdgmxq" />
        <main data-id="element-5102" data-mp="iwgk4x62pqhl">
          <HeroSection h1Override={<>
                Tu Cerebro Te{' '}
                <span className="relative inline-block" data-id="element-5104" data-mp="1bevo28hwze1o">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-5105" data-mp="1bgf35vru3j1v">
                    Miente
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-5106" data-mp="2pcgrx3jw3125" />
                </span>
                {'. '}
                <br data-id="element-5107" data-mp="2ybbve7vjtx1r" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-5108" data-mp="2yb27cpu2dzyp">
                  Nuestra IA No.
                </span>
              </>} data-id="element-5103" data-mp="ex7tw2a8saqs" />
          <TrustSection data-id="element-5109" data-mp="38asyqinbvyuk" />
          <FeaturesSection data-id="element-5110" data-mp="389hwin9j6z5k" />
          <GuaranteesSection data-id="element-5111" data-mp="3886t4ojzztez" />
          <ToolsSection data-id="element-5112" data-mp="3d8kw3s6qsd65" />
          <ComparisonSection data-id="element-5113" data-mp="3d7t7j1bkbfpd" />
          <PricingSection data-id="element-5114" data-mp="3d6zwvp9hg61y" />
          <FAQSection data-id="element-5115" data-mp="3i02wof4usbql" />
          <CTASection data-id="element-5116" data-mp="3i0vswm66riuh" />
        </main>
        <Footer data-id="element-5117" data-mp="3i1xgtr8avztm" />
      </div>
    </>;
}